import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Unit } from '../../settings-module/models/unit';
import { Job } from '../../jobs-module/models/job.model';
import {
  JobListingItem,
  LISTING_ITEM_TYPE,
} from '../../jobs-module/models/listing.model';

@Component({
  selector: 'mj-job-listing-item',
  templateUrl: './mj-job-listing-item.component.html',
  styleUrls: ['./mj-job-listing-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MjJobListingItemComponent implements OnChanges {
  @Input() listingItem: JobListingItem;
  @Input() job: Job;
  @Input() unit: Unit;
  @Input() selectedUnit: Unit;

  @Output() onItemAdded = new EventEmitter<JobListingItem>();
  @Output() onItemRemoved = new EventEmitter<JobListingItem>();
  @Output() onListingUpdated = new EventEmitter<JobListingItem>();

  undoPromise;
  listingItemType: number = null;

  public LISTING_ITEM_HEADER = LISTING_ITEM_TYPE.LISTING_ITEM_HEADER;
  public LISTING_ITEM_ABOUT_JOB = LISTING_ITEM_TYPE.LISTING_ITEM_ABOUT_JOB;
  public LISTING_ITEM_IMAGE = LISTING_ITEM_TYPE.LISTING_ITEM_IMAGE;
  public LISTING_ITEM_VIDEO = LISTING_ITEM_TYPE.LISTING_ITEM_VIDEO;
  public LISTING_ITEM_FREE_TEXT = LISTING_ITEM_TYPE.LISTING_ITEM_FREE_TEXT;
  public LISTING_ITEM_FREE_TEXT_IMAGE =
    LISTING_ITEM_TYPE.LISTING_ITEM_FREE_TEXT_IMAGE;
  public LISTING_ITEM_FOOTER = LISTING_ITEM_TYPE.LISTING_ITEM_FOOTER;
  public LISTING_ITEM_JOBS = LISTING_ITEM_TYPE.LISTING_ITEM_JOBS;
  public LISTING_ITEM_ABOUT_OFFICE =
    LISTING_ITEM_TYPE.LISTING_ITEM_ABOUT_OFFICE;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.listingItem && this.listingItem && !this.listingItemType) {
      this.listingItemType = this.listingItem.type;
    }
  }

  scheduleItemRemoval(item) {
    this.undoPromise = setTimeout(() => {
      this.undoPromise = null;
      this.onItemRemoved.emit(item);
    }, 5000);
  }

  undoRemoval() {
    clearTimeout(this.undoPromise);
    this.undoPromise = null;
  }

  updateListing($event: JobListingItem) {
    this.onListingUpdated.emit($event);
  }
}
